import api from 'api'

const wxLogin = {
  namespaced: true,
  state: {
    show: false,
    info: null,
    loading: false,
    showBindAccountDialog: false,
    wechatAccount: null,
    showBindOtherAccountDialog: false,
  },
  getters: {
    show: (state) => state.show,
    info: (state) => state.info,
    loading: (state) => state.loading,
    showBindAccountDialog: (state) => state.showBindAccountDialog,
    wechatAccount: (state) => state.wechatAccount,
    showBindOtherAccountDialog: (state) => state.showBindOtherAccountDialog,
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setWxLoginInfo(state, info) {
      state.info = info
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setShowBindAccountDialog(state, show) {
      state.showBindAccountDialog = show
    },
    setWechatAccount(state, wechatAccount) {
      state.wechatAccount = wechatAccount
    },
    setShowBindOtherAccountDialog(state, show) {
      state.showBindOtherAccountDialog = show
    },
  },
  actions: {
    updateWechatAccount({ commit }, wechatAccount) {
      commit('setWechatAccount', wechatAccount)
    },
    toggleLoading({ commit }, loading) {
      commit('setLoading', loading)
    },
    show({ commit }) {
      commit('setShow', true)
    },
    hide({ commit, state }) {
      commit('setShow', false)
    },
    get({ dispatch, commit, state }) {
      api.call('POST', '/wechat_account/generate_oa_login_qrcode', {}, (res) => {
        console.log(res)
        const {
          data: { code, data },
        } = res
        if (code == 0) {
          commit('setWxLoginInfo', data)
          commit('setShow', true)
          commit('setLoading', true)
        }
      })
    },

    updateBindAccountDialog({ commit }, show) {
      commit('setShowBindAccountDialog', show)
    },
    updateBindOtherAccountDialog({ commit }, show) {
      commit('setShowBindOtherAccountDialog', show)
    },
  },
}

export default wxLogin
